import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import Home from './pages/Home';

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/el/*" element={<Home />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;